module.exports = function() {
  return new Worker(__webpack_public_path__ + "e8c744e60626199254c0.worker.js");
};